module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/signup-cover-8b7c1a9bea27300c6b632304da458ad3.jpg";